import { Revisione53State } from '../store/revisione53.reducers';
import { Store } from '@ngrx/store';
import { FormGroup } from '@angular/forms';
import { debounceTime, Subscription, take } from 'rxjs';
import { Revisione53CoreActions } from '../store/revisione53.actions';
import { AEIncaricoEntity, MyVerbale } from '../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { Sezionealbonazenticoop } from '../models/interfaces/dati-business.interface';
import { Revisione53DatiBusinessSelectors } from '../store/selectors/dati-business.selectors';
import { revisione53DatiSecondariSelectors } from '../store/selectors/dati-secondari.selectors';

const formStoreValueStatusChanges = (store: Store<Revisione53State>, form: FormGroup): Subscription[] => {
    return [
        form.valueChanges.pipe(debounceTime(150)).subscribe((values: MyVerbale) => {
            const my_Verbale = cloneDeep(form.getRawValue());
            store.dispatch(Revisione53CoreActions.updateMyVerbale({ my_Verbale }));
        }),
    ];
};

export const setInitialTipoSezEnte = (verbale: MyVerbale, store: Store<Revisione53State>): void => {
    const datiIdentificativi = verbale?.my_SezioneI__Rilevazione?.my_DatiIdentificativi;

    if (isNilOrEmpty(datiIdentificativi?.my_TipoSezEnte) && !isNilOrEmpty(datiIdentificativi?.my_SezEnte)) {
        let sezioneAlbo: Sezionealbonazenticoop[] = [];
        store
            .select(Revisione53DatiBusinessSelectors.getSezioneAlboNazEntiCoop)
            .pipe(take(1))
            .subscribe((res) => (sezioneAlbo = res));
        const found = sezioneAlbo.find((s) => s.id_sezioneAlboNazEntiCoop == datiIdentificativi.my_SezEnte);
        if (found) {
            verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte = found.Id_tipoSezione;
        }
    }
};

// VBS (OnLoad ~1584): precarica ChiusuraEsercizio dall'anagrafica (AE_Incarico.dataChiusuraExer) se non è
// già stato inserito dal revisore, cosi il campo si presenta compilato come in InfoPath.
export const setInitialChiusuraEsercizio = (verbale: MyVerbale, store: Store<Revisione53State>): void => {
    const effettivitaBaseSociale = verbale?.my_SezioneI__Rilevazione?.my_EffettivitaBaseSociale;

    if (isNilOrEmpty(effettivitaBaseSociale?.my_ChiusuraEsercizio)) {
        let aeIncarico: AEIncaricoEntity[] = [];
        store
            .select(revisione53DatiSecondariSelectors.getAEIncarico)
            .pipe(take(1))
            .subscribe((res) => (aeIncarico = res));
        const found = aeIncarico.find((incarico) => incarico.id_assegnazione === verbale.my_IdAssegnazione);
        if (!isNilOrEmpty(found?.dataChiusuraExer)) {
            verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_ChiusuraEsercizio = found.dataChiusuraExer;
        }
    }
};

export const FormStoreHelpers = {
    formStoreValueStatusChanges,
};
